import React from "react";

import { NextSeo } from "next-seo";

import MainLayout from "../components/MainLayout";
import { SeoBaselineConfig } from "../seo";
import HomeView from "../views/HomeView";

export default function Page() {
  return (
    <>
      <NextSeo
        {...{
          ...SeoBaselineConfig,
          title: "飛天奶茶創作者事務所",
          titleTemplate: "%s",
        }}
      />
      <HomeView />
    </>
  );
}

Page.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>;
};

export const getStaticProps = async () => ({
  props: {},
  revalidate: 86400,
});
